import { Col, Row, } from "antd";
import { useGetContractByType } from "apps/CustomerPanel/Ad/ServerSideStates";
import { Helmet } from "react-helmet-async";
import StaticPageBanner from "apps/Common/StaticPageBanner";

const ContractRuleAgreement = () => {


  const contract = useGetContractByType("2003");
  const html = contract?.data?.data?.content || "";
  return (



    <Col xs={24}>
      <Col xs={24}>
        <div className="w-full">
          <StaticPageBanner
            title={`${contract?.data?.data?.name || ""}`}
            description={"Sözleşme detaylarını aşağıda bulabilirsiniz."}
          />
        </div>
      </Col>
      <Row className="" gutter={[40, 40]}>
        <Helmet>
          <title className="capitalize">{"Sözleşmeler"}</title>
        </Helmet>
        <Col xs={24} className="text-base pl-10 pr-10">
          <div className="text-base pl-16 pr-16" style={{ fontSize: '20px', fontFamily: 'inherit' }} dangerouslySetInnerHTML={{ __html: html }} />
        </Col>
      </Row>
    </Col>

  );



};

export default ContractRuleAgreement
